import React, { useState } from 'react';
import { MicIcon, VolumeIcon, PauseIcon } from 'lucide-react';
interface VoiceControlsProps {
  onStartRecording: () => void;
  onStopRecording: () => void;
  onTextToSpeech: () => void;
  isListening: boolean;
  isSpeaking: boolean;
  isRecordingEnabled?: boolean;
  isTextToSpeechEnabled?: boolean;
}
const VoiceControls = ({
  onStartRecording,
  onStopRecording,
  onTextToSpeech,
  isListening,
  isSpeaking,
  isRecordingEnabled = true,
  isTextToSpeechEnabled = true
}: VoiceControlsProps) => {
  const handleRecordToggle = () => {
    if (isListening) {
      onStopRecording();
    } else {
      onStartRecording();
    }
  };
  const handleTextToSpeech = () => {
    onTextToSpeech();
  };
  return <div className="flex items-center justify-center space-x-4 py-4" data-id="element-291">
      {isRecordingEnabled && <button onClick={handleRecordToggle} className={`p-5 rounded-full shadow-soft flex items-center justify-center transition-all
            ${isListening ? 'bg-soft-coral text-white animate-pulse' : 'bg-white dark:bg-slate-800 text-soft-coral'}`} aria-label={isListening ? 'Stop recording' : 'Start recording'} data-id="element-292">
          <MicIcon className="w-8 h-8" data-id="element-293" />
        </button>}
      {isTextToSpeechEnabled && <button onClick={handleTextToSpeech} className={`p-5 rounded-full shadow-soft flex items-center justify-center transition-all
            ${isSpeaking ? 'bg-lavender text-white' : 'bg-white dark:bg-slate-800 text-lavender'}`} aria-label={isSpeaking ? 'Stop speaking' : 'Read aloud'} data-id="element-294">
          {isSpeaking ? <PauseIcon className="w-8 h-8" data-id="element-295" /> : <VolumeIcon className="w-8 h-8" data-id="element-296" />}
        </button>}
    </div>;
};
export default VoiceControls;